import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import { get } from "lodash";
import { ADD_DECISION_ACTION } from "../constant";

export const addDecisionAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: ADD_DECISION_ACTION.ADD_DECISION_START
    });
    return requestMethod(apiServices.addDecision(params))
      .then(response => {
        dispatch({
          type: ADD_DECISION_ACTION.ADD_DECISION_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: ADD_DECISION_ACTION.ADD_DECISION_FAILURE
        });
      });
  };
};

export const getMinistryListAction = (requestMethod = request, id) => {
  return function(dispatch) {
    dispatch({
      type: ADD_DECISION_ACTION.ADD_DECISION_MINISTRY_LIST_START
    });
    return requestMethod(apiServices.getMinistryListById(id))
      .then(response => {
        dispatch({
          type: ADD_DECISION_ACTION.ADD_DECISION_MINISTRY_LIST_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: ADD_DECISION_ACTION.ADD_DECISION_MINISTRY_LIST_ERROR
        });
      });
  };
};

export const getChildIssuesAction = (requestMethod = request, id) => {
  return requestMethod(apiServices.getChildIssues(id))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(error => error);
};

export const addProjectDecisionAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.addProjectDecision(params))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(e => {
      console.log("Error -", e.message);
    });
};
